import script from "./Mbank-Externalv2.vue?vue&type=script&setup=true&lang=js"
export * from "./Mbank-Externalv2.vue?vue&type=script&setup=true&lang=js"

import "./Mbank-Externalv2.vue?vue&type=style&index=0&id=79236367&lang=scss&scoped=true"
import "./Mbank-Externalv2.vue?vue&type=style&index=1&id=79236367&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-79236367"]])

export default __exports__